import Vue from "vue";
import {
  GetterTree,
  ActionTree,
  MutationTree
} from "vuex";
import { BusinessUnit } from "@/shared/models/businessUnit";
import { ListModel } from "@/shared/models/listModel";

export class BusinessUnitStorage {
  tenantId = 0;
  userId = 0;
  businessUnitId = 0;
}

export class BusinessUnitState {
  activeBusinessUnit?: BusinessUnit = {
    id: 0,
    tenantId: 0,
    name: "",
    code: "",
    streetName: "",
    houseNumber: "",
    houseNumberAppendix: "",
    city: "",
    cityPostalName: "",
    postalCodeId: null,
    cadastralNumber: "",
    buildingNumber: "",
    buildingSectionNumber: "",
    validFrom: "",
    validTo: "",
    note: "",
    status: false,
    isHeadquarters: false,
    isVirtual: false,
    isRegistered: false,
    ownerCustomerId: null,
    isOwnerBusinessUnit: false,
    timeZoneId: "",
    shouldBeLinkedToFiscalizationService: false,
    isLinkedToFiscalizatioService: false
  };

  availableBusinessUnits?: BusinessUnit[] = [];
  allBusinessUnits?: BusinessUnit[] = [];

  storedData?: BusinessUnitStorage[] = [];
}

const storageKey = "pms.bu";

const initialState = new BusinessUnitState();

const state = { ...initialState };

function saveState() {
  const stringified = JSON.stringify(state.storedData);
  if (state.storedData && localStorage.getItem(storageKey) != stringified) {
    localStorage.setItem(storageKey, stringified);
  }
}

const getters: GetterTree<BusinessUnitState, any> = {
  activeBusinessUnit: (state) => state.activeBusinessUnit,
  availableBusinessUnits: (state) => state.availableBusinessUnits,
  allBusinessUnits: (state) => state.allBusinessUnits,
  businessUnitStorage: (state) => state.storedData,
};

const actions: ActionTree<BusinessUnitState, any> = {
  refreshBusinessUnits({ commit }) {
    return Vue.axios
      .get<ListModel<BusinessUnit>>(`/businessUnits`, {
        params: {
            shouldGetAll: true,
        },
      })
      .then(
        ({ data }) =>
          (commit("setAvailableBusinessUnits", data.result?.filter((x) => x.status)),
          (commit("setAllBusinessUnits", data.result))),
      );
  },
  setBusinessUnit({commit}, payload ) {
    commit("setActiveBusinessUnit", payload);
  },
  async setBusinessUnitFromStorage({dispatch} ,payload) {
    const stored = localStorage.getItem(storageKey);
    if((state.availableBusinessUnits?.length ?? 0) === 0) {
      await dispatch("refreshBusinessUnits", payload.tenantId);
    }
    if (stored) {
      try {
        const parsed = JSON.parse(stored) as BusinessUnitStorage[];
        state.storedData = parsed;
        const id = parsed.find(x => x.userId == payload.userId && x.tenantId == payload.tenantId)?.businessUnitId;
        state.activeBusinessUnit = state.availableBusinessUnits?.find(x => x.id == id);
      } catch {
        /* empty */
      }
    }
    else {
      state.storedData = [];
      state.activeBusinessUnit = undefined;
    }
  },
  clearBusinessUnits({commit}) {
    commit("clearBusinessUnits");
  },
};
const mutations: MutationTree<BusinessUnitState> = {
  reset: (state) => {
    Object.assign(state, initialState);
  },
  setAvailableBusinessUnits: (state, value) => {
    state.availableBusinessUnits = value.slice();
  },
  setAllBusinessUnits: (state, value) => {
    state.allBusinessUnits = value.slice();
  },
  setActiveBusinessUnit: (state, value) => {
    state.activeBusinessUnit = value.businessUnit;
    const data = {
      tenantId: value.tenantId,
      userId: value.userId,
      businessUnitId: value.businessUnit.id
    } as BusinessUnitStorage;
    const x = state.storedData?.findIndex(x => x.userId == data.userId && x.tenantId == data.tenantId);
    if(x !== undefined && x !== -1)
    {
      state.storedData?.splice(x, 1, data);
    }
    else
    {
      state.storedData?.push(data);
    }
    saveState();
  },
  clearBusinessUnits: (state) => {
    state.availableBusinessUnits = [];
  }
};

export default {
  namespaced: true,
  state: () => state,
  getters,
  actions,
  mutations,
};